var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSilver(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 66,
    height: 66,
    viewBox: "0 0 66 66",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d_238_9911)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M30.244 5.92236C31.7742 4.32821 34.3237 4.32821 35.854 5.92236L36.5321 6.62881C37.4849 7.62139 38.8914 8.03651 40.2304 7.72042L41.1735 7.49782C43.3152 6.99225 45.4493 8.3633 45.8798 10.5214L46.0869 11.5596C46.3537 12.8971 47.3018 13.997 48.5854 14.4582L49.5637 14.8097C51.619 15.5481 52.6632 17.8339 51.8757 19.8709L51.4741 20.9098C50.9859 22.1727 51.1898 23.5986 52.0125 24.6741L52.6859 25.5544C54.0098 27.2853 53.6531 29.7661 51.895 31.0536L51.0231 31.6922C49.9278 32.4944 49.3302 33.8098 49.4466 35.1625L49.5406 36.2538C49.7285 38.4376 48.0752 40.3451 45.8868 40.4692L44.8905 40.5257C43.522 40.6033 42.2955 41.3957 41.6623 42.6113L41.1931 43.5117C40.1734 45.4693 37.7304 46.1864 35.8144 45.0905L34.9794 44.6129C33.7834 43.9289 32.3146 43.9289 31.1186 44.6129L30.2836 45.0905C28.3675 46.1864 25.9246 45.4693 24.9048 43.5117L24.4357 42.6113C23.8025 41.3957 22.576 40.6033 21.2075 40.5257L20.2112 40.4692C18.0228 40.3451 16.3695 38.4376 16.5574 36.2538L16.6513 35.1625C16.7678 33.8098 16.1702 32.4944 15.0749 31.6922L14.203 31.0536C12.4449 29.7661 12.0882 27.2852 13.4121 25.5544L14.0855 24.6741C14.9082 23.5986 15.1121 22.1727 14.6239 20.9098L14.2223 19.8709C13.4348 17.8339 14.479 15.5481 16.5343 14.8097L17.5126 14.4582C18.7962 13.997 19.7443 12.8971 20.0111 11.5596L20.2182 10.5214C20.6487 8.36331 22.7828 6.99225 24.9245 7.49782L25.8676 7.72042C27.2066 8.03651 28.613 7.62139 29.5658 6.62881L30.244 5.92236Z",
    fill: "url(#paint0_linear_238_9911)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M30.244 5.92236C31.7742 4.32821 34.3237 4.32821 35.854 5.92236L36.5321 6.62881C37.4849 7.62139 38.8914 8.03651 40.2304 7.72042L41.1735 7.49782C43.3152 6.99225 45.4493 8.3633 45.8798 10.5214L46.0869 11.5596C46.3537 12.8971 47.3018 13.997 48.5854 14.4582L49.5637 14.8097C51.619 15.5481 52.6632 17.8339 51.8757 19.8709L51.4741 20.9098C50.9859 22.1727 51.1898 23.5986 52.0125 24.6741L52.6859 25.5544C54.0098 27.2853 53.6531 29.7661 51.895 31.0536L51.0231 31.6922C49.9278 32.4944 49.3302 33.8098 49.4466 35.1625L49.5406 36.2538C49.7285 38.4376 48.0752 40.3451 45.8868 40.4692L44.8905 40.5257C43.522 40.6033 42.2955 41.3957 41.6623 42.6113L41.1931 43.5117C40.1734 45.4693 37.7304 46.1864 35.8144 45.0905L34.9794 44.6129C33.7834 43.9289 32.3146 43.9289 31.1186 44.6129L30.2836 45.0905C28.3675 46.1864 25.9246 45.4693 24.9048 43.5117L24.4357 42.6113C23.8025 41.3957 22.576 40.6033 21.2075 40.5257L20.2112 40.4692C18.0228 40.3451 16.3695 38.4376 16.5574 36.2538L16.6513 35.1625C16.7678 33.8098 16.1702 32.4944 15.0749 31.6922L14.203 31.0536C12.4449 29.7661 12.0882 27.2852 13.4121 25.5544L14.0855 24.6741C14.9082 23.5986 15.1121 22.1727 14.6239 20.9098L14.2223 19.8709C13.4348 17.8339 14.479 15.5481 16.5343 14.8097L17.5126 14.4582C18.7962 13.997 19.7443 12.8971 20.0111 11.5596L20.2182 10.5214C20.6487 8.36331 22.7828 6.99225 24.9245 7.49782L25.8676 7.72042C27.2066 8.03651 28.613 7.62139 29.5658 6.62881L30.244 5.92236Z",
    fill: "url(#paint1_linear_238_9911)",
    fillOpacity: 0.1
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17.7617 25.3476C17.7617 16.9047 24.6061 10.0603 33.049 10.0603C41.4919 10.0603 48.3362 16.9046 48.3362 25.3476V25.662C48.3362 34.1049 41.4919 40.9492 33.049 40.9492C24.6061 40.9492 17.7617 34.1049 17.7617 25.662V25.3476Z",
    fill: "black",
    fillOpacity: 0.04
  }), /*#__PURE__*/React.createElement("path", {
    d: "M19.2135 25.3476C19.2135 17.7064 25.4079 11.5121 33.049 11.5121C40.6901 11.5121 46.8845 17.7064 46.8845 25.3476V25.662C46.8845 33.3031 40.6901 39.4975 33.049 39.4975C25.4078 39.4975 19.2135 33.3031 19.2135 25.662V25.3476Z",
    stroke: "white",
    strokeOpacity: 0.3,
    strokeWidth: 2.90353
  }), /*#__PURE__*/React.createElement("path", {
    d: "M30.5293 28.2958L27.594 25.3303C27.4359 25.1703 27.2214 25.0804 26.9976 25.0804C26.7738 25.0804 26.5593 25.1703 26.4012 25.3303C26.0713 25.6636 26.0713 26.202 26.4012 26.5353L29.9372 30.1076C30.2671 30.4409 30.8 30.4409 31.1299 30.1076L40.0797 21.0658C40.4096 20.7325 40.4096 20.1941 40.0797 19.8608C39.9216 19.7008 39.707 19.6108 39.4833 19.6108C39.2595 19.6108 39.045 19.7008 38.8869 19.8608L30.5293 28.2958Z",
    fill: "white",
    stroke: "#FDFDFD",
    strokeWidth: 0.580707
  }), /*#__PURE__*/React.createElement("path", {
    d: "M33.0491 11.746C33.0491 10.8652 33.765 10.1426 34.6412 10.2331C37.4075 10.5189 40.0566 11.5454 42.3028 13.218C44.977 15.2094 46.9375 18.0103 47.893 21.2046C48.8486 24.399 48.7482 27.8164 47.6068 30.9491C46.4654 34.0819 44.3438 36.7628 41.5573 38.5938C38.7708 40.4247 35.468 41.3079 32.1396 41.1122C28.8111 40.9165 25.6346 39.6522 23.0818 37.5074C20.5291 35.3625 18.7364 32.4513 17.97 29.2064C17.3263 26.4808 17.4355 23.6419 18.2712 20.9894C18.5358 20.1493 19.4832 19.7789 20.2917 20.1285C21.1002 20.4781 21.4613 21.4155 21.2191 22.2624C20.6428 24.2777 20.5886 26.4161 21.0744 28.4732C21.683 31.0501 23.1067 33.3619 25.1339 35.0652C27.161 36.7685 29.6836 37.7724 32.3268 37.9279C34.97 38.0833 37.5928 37.3819 39.8057 35.9279C42.0185 34.4739 43.7033 32.3449 44.6097 29.8571C45.5161 27.3693 45.5958 24.6555 44.837 22.1188C44.0782 19.5821 42.5213 17.3578 40.3976 15.7764C38.7023 14.5141 36.7181 13.7151 34.6396 13.4442C33.7661 13.3303 33.0491 12.6269 33.0491 11.746Z",
    fill: "white",
    fillOpacity: 0.5
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_238_9911",
    x: -1,
    y: -1,
    width: 68.0981,
    height: 68.0979,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 8
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 6
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.917647 0 0 0 0 0.690196 0 0 0 0 0.12549 0 0 0 0.4 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_238_9911"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_238_9911",
    result: "shape"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_238_9911",
    x1: 18.743,
    y1: 7.12982,
    x2: 42.9305,
    y2: 45.2547,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#C5C5C5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#767676"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_238_9911",
    x1: 3.42686,
    y1: -0.444911,
    x2: 36.9252,
    y2: 59.3467,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSilver);
export default __webpack_public_path__ + "static/media/silver.61a7bef0c0caea42d626942f9db58fba.svg";
export { ForwardRef as ReactComponent };